var map = {
	"./1_MG_0588.webp": "./src/img/brands/union-fresco/1_MG_0588.webp",
	"./Felicitas_Ernst_Unico_Fresco_publicidad(1).webp": "./src/img/brands/union-fresco/Felicitas_Ernst_Unico_Fresco_publicidad(1).webp",
	"./Felicitas_Ernst_Unico_Fresco_publicidad(2).webp": "./src/img/brands/union-fresco/Felicitas_Ernst_Unico_Fresco_publicidad(2).webp",
	"./Felicitas_Ernst_Unico_Fresco_publicidad(3).webp": "./src/img/brands/union-fresco/Felicitas_Ernst_Unico_Fresco_publicidad(3).webp",
	"./Felicitas_Ernst_Unico_Fresco_publicidad(4).webp": "./src/img/brands/union-fresco/Felicitas_Ernst_Unico_Fresco_publicidad(4).webp",
	"./Felicitas_Ernst_Unico_Fresco_publicidad(5).webp": "./src/img/brands/union-fresco/Felicitas_Ernst_Unico_Fresco_publicidad(5).webp",
	"./Felicitas_Ernst_Unico_Fresco_publicidad.webp": "./src/img/brands/union-fresco/Felicitas_Ernst_Unico_Fresco_publicidad.webp",
	"./Felicitas_Ernst_Unico_Fresco_publicidad_.webp": "./src/img/brands/union-fresco/Felicitas_Ernst_Unico_Fresco_publicidad_.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/union-fresco sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";